module.exports = __webpack_public_path__ + "static/media/HCMM132.2dc01b89.jpg";